import React from 'react';

import Box from '@material-ui/core/Box'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Typography from '@material-ui/core/Typography';


const AdsAddBox=React.memo(props=>{
  const {
    light,
    onClick,
    fullWidth=false,
  }=props
  return (
    <Box
      //grid item tambah iklan
      component={fullWidth?"div":"span"}
      style={{
        display:"inline-block",
        width:fullWidth?"100%":"74px",
        height:"74px",
        overflow:"hidden",
        border:"4px dashed #888888",
        borderRadius:"8px",
        //margin:"auto 2px",
        position:"relative",
        cursor:"pointer",
        textAlign:"center",
        margin:fullWidth?"0px 16px 0p 16px":null,
      }}
      tabIndex="0"
      onKeyDown={onClick}
      onClick={onClick}
    >
      <AddCircleOutlineIcon style={{color:light?"white":"black",fontSize:"30px",}}/>

      <Typography
         style={{
          position:"absolute",
          top:28,
          width:fullWidth?"100%":"72px",
          textAlign:"center",
          color:light?"white":"black",
          //fontSize:"50px",
        }}
      >
        Pasang
      </Typography>
      
      <Typography
         style={{
          position:"absolute",
          bottom:0,
          width:fullWidth?"100%":"72px",
          textAlign:"center",
          color:light?"white":"black",
          //fontSize:"50px",
        }}
      >
        Iklan
      </Typography>
    </Box>
  )
})

export default AdsAddBox